(function () {
  function initGuide(root) {
    if (!root || root.dataset.erCompareReady === 'true') return;
    root.dataset.erCompareReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-erc-scenario-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-erc-scenario-panel]'));

    function activateScenario(key, focusTab) {
      tabs.forEach(function (tab) {
        var isActive = tab.dataset.ercScenarioTab === key;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
        if (isActive && focusTab) tab.focus();
      });

      panels.forEach(function (panel) {
        var isActive = panel.dataset.ercScenarioPanel === key;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateScenario(tab.dataset.ercScenarioTab, false);
      });

      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        var offset = event.key === 'ArrowRight' ? 1 : -1;
        var nextIndex = (index + offset + tabs.length) % tabs.length;
        activateScenario(tabs[nextIndex].dataset.ercScenarioTab, true);
      });
    });

    root.querySelectorAll('[data-erc-model-jump]').forEach(function (link) {
      link.addEventListener('click', function () {
        var key = link.dataset.ercModelJump;
        window.setTimeout(function () {
          var card = document.querySelector('[data-erc-model="' + key + '"]');
          if (!card) return;
          card.classList.remove('is-pulsing');
          void card.offsetWidth;
          card.classList.add('is-pulsing');
        }, 420);
      });
    });

  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-er-compare-guide]').forEach(initGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
